import { FloatNumberInput } from "@/shared/components/domain/qpm/inputs/number-input";
import { Label } from "@/shared/components/ui/label";
import { useQpmCatalogItemSetBasePriceMutation } from "@/services/backend/qpm/catalog/api/catalog-api";
import { usePersistenceContext } from "@/shared/lib/persistence-state/context";
import { PersistenceState } from "@/shared/lib/persistence-state/persistence-state";

export function CatalogItemBasePriceComponent({
  catalogItemId,
  priceEuros,
}: {
  catalogItemId: string;
  priceEuros?: number;
}) {
  const [update, saveState] = useQpmCatalogItemSetBasePriceMutation();
  const { setPersistenceState } = usePersistenceContext();

  const persist = (euros: number) => {
    setPersistenceState(PersistenceState.SAVING);
    update({
      catalogItemId,
      euros,
      effectiveOn: new Date().toISOString(),
    })
      .unwrap()
      .then(() => setPersistenceState(PersistenceState.SAVED))
      .catch(() => setPersistenceState(PersistenceState.ERROR));
  };

  return (
    <div className="grid grid-cols-4 gap-1.5">
      <Label className="col-span-2" htmlFor="price">
        Preis
      </Label>

      <div className="col-span-2">
        <FloatNumberInput
          id="price"
          value={priceEuros || 0}
          disabled={saveState.isLoading}
          onBlur={persist}
        />
      </div>
    </div>
  );
}
